import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const MonitorsIncidentsPerDistrict = () => {

    const monitorReport = true;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="DISTRICT" disaggregation = "validity" />
        </>
    
  )
}

export default MonitorsIncidentsPerDistrict